import AdminWarehouseDetails from './AdminWarehouseDetails';
import AdminWarehouses from './AdminWarehouses';


export {
    AdminWarehouseDetails,
    AdminWarehouses,
};

export default AdminWarehouses;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Warehouses/index.tsx